module.exports = __webpack_public_path__ + "img/medlocalizer.5bffeff8.png";